import { Stack, Box } from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"

export default function TwoColumn({ block, colorMode = "light" }) {
    const columnOneWidth = block.widths + "%"
    const columnTwoWidth = 100 - block.widths + "%"
    const gap = block.gap ? block.gap : "20px"
    return (
        <Wrapper className={`body colorMode--${colorMode} ${block.cssClass ? block.cssClass : ""}`} py="10px">
            <Stack className="twoColumnMatrixBlock" direction={{ base: "column", md: "row" }} gap={gap}>
                <Box w={{ base: "100%", md: columnOneWidth }} dangerouslySetInnerHTML={{ __html: block.columnOne }} />
                {block?.verticalColumnDivider && (
                    <Box className="twoColumnMatrixBlock__divider" padding={{ base: "20px 0 0", md: "10px 0 0 0" }}>
                        <Box
                            width={{ base: "100%", md: "1px" }}
                            height={{ base: "1px", md: "100%" }}
                            bgColor="var(--hr, black)"
                        />
                    </Box>
                )}
                <Box w={{ base: "100%", md: columnTwoWidth }} dangerouslySetInnerHTML={{ __html: block.columnTwo }} />
            </Stack>
        </Wrapper>
    )
}
